
import api from '../../../services/service_report'
import apipos from '../../../services/service_pos'
var moment = require('moment')

export default {
  data () {
    return {
      host_list: [],
      host: '',
      datenow: moment(new Date(), 'YYYY/MM/DD'),
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      }
    }
  },
  methods: {
    onChange (date) {
      this.datenow = moment(date, 'YYYY/MM/DD')
    },
    getListHost () {
      apipos.getHostShift(
        this.REST_URL,
        this.header,
        result => {
          if (result.response === 'success') {
            this.host_list = result.data
            this.host = this.host_list[0]
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลจุดขายไม่ได้',
              description: result.message
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    printSendShift () {
      var obj = {
        host_code: this.host.host_code,
        doc_date: this.dateFormatDMY2(this.datenow),
        printer_port: this.host.printer_port
      }
      this.$store.commit('Loading')
      api.PrintsendShiftHost(
        this.REST_URL,
        this.header,
        obj,
        result => {
          if (result.response === 'success') {
            this.alert_msg('success', 'พิมพ์ใบนำส่งเงิน', 'พิมพ์ใบนำส่งเงินประจำ ' + this.host.host_name + ' เรียบร้อย')
            $('#ModalReport').modal('hide')
            $('body').on('hidden.bs.modal', '.modal', function () {
              console.clear()
              $(this).removeData('bs.modal')
            })
          } else {
            this.alert_msg('warning', 'พิมพ์ใบนำส่งเงิน', result.message)
            $('#ModalReport').modal('hide')
            $('body').on('hidden.bs.modal', '.modal', function () {
              console.clear()
              $(this).removeData('bs.modal')
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          this.$store.commit('Loading')
          $('#ModalReport').modal('hide')
          $('body').on('hidden.bs.modal', '.modal', function () {
            console.clear()
            $(this).removeData('bs.modal')
          })
        })
    }
  },
  mounted () {
    $('#ModalReport').on(
      'show.bs.modal',
      function () {
        this.getListHost()
      }.bind(this)
    )
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/report/sendShiftHost.js